import { type IAdvancedRichText } from '../../../../../../../inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '../../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { OptionsGroupDividerLabel } from './OptionsGroupDividerLabel.tsx';

export interface IOptionsGroupRichTextAdvancedDividerLabelRenderProps {
  text?: IAdvancedRichText;
}

/**
 * Renderizza il testo avanzato e lo stile del Divider (Label)
 */
export function OptionsGroupRichTextAdvancedDividerLabelRender(
  props: IOptionsGroupRichTextAdvancedDividerLabelRenderProps,
) {
  if (!props.text) return null;

  return (
    <OptionsGroupDividerLabel>
      <RichTextAdvancedRender inline text={props.text} />
    </OptionsGroupDividerLabel>
  );
}
